'use client';

import { useTranslations } from 'next-intl';
import { HeroBanner, type HeroBannerPageTitle } from '@/components/frontend/common/hero-banner';
import { DemoItems } from './demo-items';
import { DemoFaqs } from './demo-faqs';

type DemoItem = { id: string; title: string; description: string; image?: string | null };
type DemoFaq = { question: string; answer: string };

export function DemoPageContent({
    initialDemoItems,
    initialDemoFaqs,
    initialPageTitle,
}: {
    initialDemoItems?: DemoItem[];
    initialDemoFaqs?: DemoFaq[];
    initialPageTitle?: HeroBannerPageTitle | null;
} = {}) {
    const t = useTranslations('demoPage');

    return (
        <div className="bg-white dark:bg-black text-gray-900 dark:text-white">
            <HeroBanner
                page="free-mlm-software-demo"
                title={t('intro.paragraph1')}
                description={t('intro.paragraph2')}
                className="border-b border-gray-200 dark:border-gray-900"
                initialPageTitle={initialPageTitle}
            />

            <DemoItems initialItems={initialDemoItems} />

            <DemoFaqs initialFaqs={initialDemoFaqs} />
        </div>
    );
}

